import React from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import s from "./logo.module.scss";

class Logo extends React.PureComponent {
  static defaultProps = {
    link: "/"
  };
  static propTypes = {
    // link: PropTypes.oneOfType(PropTypes.string, PropTypes.bool),
    title: PropTypes.string
  };

  render() {
    let picture = (
      <svg
        width="121"
        height="36"
        version="1.1"
        viewBox="0 0 241.77 71.111"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g transform="translate(21.927 16.824)" fill="#fff">
          <path d="m185.91-14.433v57.312h33.935v-9.563h-22.654v-47.638c-3.7603-0.03677-7.5205-0.07354-11.281-0.11031z" />
          <path d="m139.56 20.536h14.896c-2.462-7.5018-4.924-15.004-7.386-22.505-2.5032 7.5018-5.0065 15.004-7.5097 22.505zm-19.187 22.025c6.8994-18.934 13.799-37.868 20.698-56.802h12.146c7.0162 18.927 14.032 37.855 21.049 56.782h-12.99c-1.4386-4.1839-2.8771-8.3677-4.3157-12.552h-19.648c-1.5254 4.2421-3.0509 8.4842-4.5763 12.726-4.1207-0.05141-8.2414-0.10282-12.362-0.15423z" />
          <path d="m61.72-14.161v57.014h11.46v-38.494c7.6189 12.765 15.238 25.53 22.857 38.296h11.993v-56.972h-11.215c0.07054 13.091 0.14108 26.181 0.21162 39.272-7.627-13.088-15.254-26.176-22.881-39.265-4.1416 0.04992-8.2832 0.09984-12.425 0.14976z" />
        </g>
        <g
          transform="matrix(2.2689 0 0 2.239 -3.1685 .7653)"
          fill="#fff"
          fillRule="evenodd"
        >
          <g transform="translate(-833,-323)" fill="#fff">
            <g transform="translate(834,324)" fill="#fff">
              <path
                d="m0.39648-1.3418v3.3281h1.4395v3.5293h28.328v-3.5293h1.4668v-3.3281zm27.168 8.4395c-0.30008-0.033521-0.62579 0.1141-0.70898 0.5625-0.04185 4.0009-0.0116 7.9311-0.01758 11.926l1.3262-1.5195v-10.248c0.008441-0.46098-0.29752-0.68696-0.59961-0.7207zm-21.002 0.0058594c-0.31134-0.034886-0.63555 0.10621-0.70703 0.54883-0.044587 4.4695-0.00754 8.8529-0.019531 13.326 0.36435 0.54459 0.85655 1.0608 1.3281 1.584v-14.758c0.017429-0.44319-0.28848-0.66609-0.60156-0.70117zm3.002 0c-0.31044-0.034832-0.63749 0.10802-0.70898 0.55078-0.044855 5.4688-0.0073033 10.85-0.019531 16.322 0.36451 0.54506 0.85646 1.0621 1.3281 1.5859v-17.756c0.017439-0.44452-0.28739-0.66809-0.59961-0.70312zm3 0c-0.31072-0.034828-0.63745 0.10769-0.70898 0.55078-0.04497 6.4958-0.0072 12.903-0.01953 19.402l1.3281 1.5312v-20.781c0.01769-0.44507-0.28704-0.66809-0.59961-0.70312zm6 0c-0.31063-0.034853-0.63743 0.1076-0.70898 0.55078-0.04347 7.0051-0.01092 13.932-0.01953 20.934l1.3281-1.5312v-19.25c0.01753-0.44501-0.28714-0.66807-0.59961-0.70312zm3 0c-0.31046-0.03479-0.63742 0.10807-0.70898 0.55078-0.04313 6.0043-0.01154 11.931-0.01953 17.932l1.3281-1.5273v-16.252c0.017507-0.44463-0.28739-0.66814-0.59961-0.70312zm3 0c-0.3111-0.034786-0.63734 0.10709-0.70898 0.54883-0.04261 5.0038-0.01046 9.9346-0.01758 14.934l1.3262-1.5254v-13.256c0.017517-0.44422-0.28674-0.66619-0.59961-0.70117zm-9.1582 0.00977c-0.24968 0.00134-0.47764 0.14206-0.55078 0.5332-0.04546 7.2194-0.0064 14.349-0.01953 21.572v0.04297l-0.01172 0.04102c-0.1114 0.42938 0.30334 0.65959 0.68945 1.1152 0.04683-0.04318 0.09694-0.09899 0.16016-0.18164 0.13715-0.17929 0.31223-0.3913 0.49023-0.57031v-21.537l0.01563-0.046875c0.14535-0.47331-0.16736-0.81521-0.52149-0.92773-0.08314-0.026417-0.16873-0.041461-0.25195-0.041016zm-11.996 0.00391c-0.24901 0.00379-0.48312 0.14736-0.55469 0.53516-0.044433 3.4697-0.00778 6.8541-0.019531 10.328 0.36406 0.54321 0.85647 1.0582 1.3281 1.5801v-11.424l0.015625-0.048828c0.1464-0.47565-0.16721-0.81859-0.52148-0.93164-0.081074-0.025872-0.16504-0.040325-0.24805-0.039062z"
                fill="#fff"
              />
            </g>
          </g>
        </g>
      </svg>
    );

    if (this.props.link !== false) {
      picture = <Link to={this.props.link}>{picture}</Link>;
    }

    return <div className={"flex-none"}>{picture}</div>;
  }
}

export default Logo;
